import React from 'react';
import NoDataMsg from 'library/noData';
import { ResponsiveContainer, Line, LineChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, BarChart, Bar } from "recharts";
import CheckInput from 'screens/components/basic/CheckInput';

const componentName = "CombinedSales";
const Charts = ({ combinedSales, showGrossSales, ShowNetSales, ShowTotalTax, ShowDiscount, ShowGrossProfit, AverageTransactionCheck, NumberTransactionsCheck, SalesCheck }) => (

    <div>
        {
            combinedSales.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="clearfix mt-1 pl-2">
                        <CheckInput name="CombinedSalesSalesChart" text="Display Combined Sales Chart" />
                        {SalesCheck &&
                            <div>
                                <div className="row">
                                    <div className="col-lg-2 pt-1 pl-3">
                                        <CheckInput text="Gross Sales" value={true} name={`${componentName}_ShowGrossSales`} />
                                    </div>
                                    <div className="col-lg-2 pt-1 pl-3">
                                        <CheckInput text="Net Sales" value={true} name={`${componentName}_ShowNetSales`} />
                                    </div>
                                    <div className="col-lg-2 pt-1 pl-3">
                                        <CheckInput text="Total Tax" value={true} name={`${componentName}_ShowTotalTax`} />
                                    </div>
                                    <div className="col-lg-2 pt-1 pl-3">
                                        <CheckInput text="Discount" value={true} name={`${componentName}_ShowDiscount`} />
                                    </div>
                                    <div className="col-lg-2 pt-1 pl-3">
                                        <CheckInput text="Gross Profit" value={true} name={`${componentName}_ShowGrossProfit`} />
                                    </div>
                                </div>

                                <div className="col-lg-12 mt-2 bg-light clearfix" >
                                    <ResponsiveContainer width="100%" height={500}>
                                        <LineChart width={730} height={250} data={combinedSales.chart}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="date" />
                                            <YAxis label={{ value: 'Sales (Dollars)', angle: -90, position: 'insideLeft' }} />
                                            <Tooltip />
                                            <Legend />
                                            {showGrossSales ? <Line type="linear" dataKey="grossSales" strokeWidth={3} stroke="#34e8eb" name="Gross Sales" /> : ""}
                                            {ShowNetSales ? <Line type="linear" dataKey="netSales" strokeWidth={3} stroke="#0ffc17" name="Net Sales" /> : ""}
                                            {ShowTotalTax ? <Line type="linear" dataKey="totalTax" strokeWidth={3} stroke="#f003fc" name="Total Tax" /> : ""}
                                            {ShowDiscount ? <Line type="linear" dataKey="discount" strokeWidth={3} stroke="#42f5bc" name="Discount" /> : ""}
                                            {ShowGrossProfit ? <Line type="linear" dataKey="grossprofit" strokeWidth={3} stroke="#42f5e3" name="Gross Profit" /> : ""}
                                        </LineChart>
                                    </ResponsiveContainer>
                                    <br />
                                    <br />
                                </div>
                            </div>}
                        <CheckInput name="CombinedSalesAverageTransaction" text="Display Average Transaction Amount Chart" />
                        {AverageTransactionCheck &&
                            <div className="col-lg-12 mt-2 bg-light " >
                                <ResponsiveContainer width="100%" height={300}>
                                    <BarChart width={730} height={250} data={combinedSales.chart.map(x => ({ date: x.date, average: x.averageTransaction }))}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="date" />
                                        <YAxis label={{ value: 'Amount (Dollars)', angle: -90, position: 'insideLeft' }} />
                                        <Tooltip />

                                        <Bar dataKey="average" fill="#82ca9d" />
                                    </BarChart>
                                </ResponsiveContainer>
                                <br />
                                <br />
                            </div>
                        }
                        <CheckInput name="CombinedSalesNumberTransactions" text="Display Number of Transactions Chart" />
                        {NumberTransactionsCheck &&
                            <div className="col-lg-12 mt-2 bg-light " >
                                <ResponsiveContainer width="100%" height={300}>
                                    <BarChart width={730} height={250} data={combinedSales.chart.map(x => ({ date: x.date, average: x.numberTransactions }))}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="date" />
                                        <YAxis label={{ value: 'Number', angle: -90, position: 'insideLeft' }} />
                                        <Tooltip />

                                        <Bar dataKey="average" fill="#82ca9d" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </div>
                        }
                    </div>
                </div>
        }
    </div>
);

export default Charts;


